import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import {
  BrandVDriveEntity,
  DeliveryAssignmentEntity,
  LocationVDriveEntity,
} from '../types';

type VDriveStore = {
  locationVDrive: LocationVDriveEntity | null;
  setLocationVDrive: (value: LocationVDriveEntity | null) => void;
  brandVDrive: BrandVDriveEntity | null;
  setBrandVDrive: (value: BrandVDriveEntity | null) => void;
  deliveryAssignment: DeliveryAssignmentEntity | null;
  setDeliveryAssignment: (value: DeliveryAssignmentEntity | null) => void;
  applyDeliveryAssignmentToAllBrands: boolean;
  setApplyDeliveryAssignmentToAllBrands: (value: boolean) => void;
};

export const useVDrive = create<VDriveStore>()(
  devtools(
    (set) => ({
      locationVDrive: null,
      setLocationVDrive: (value) => set(() => ({ locationVDrive: value })),

      brandVDrive: null,
      setBrandVDrive: (value) => set(() => ({ brandVDrive: value })),

      deliveryAssignment: null,
      setDeliveryAssignment: (value) =>
        set(() => ({ deliveryAssignment: value })),

      applyDeliveryAssignmentToAllBrands: false,
      setApplyDeliveryAssignmentToAllBrands: (value) =>
        set(() => ({ applyDeliveryAssignmentToAllBrands: value })),
    }),
    { name: 'vDrive' }
  )
);
